import { gql } from "@apollo/client"
import { SharedDataPlan, SingleDataPlan } from "../../../utils/models"

// TODO not all data is returned
export type GetDataPlanReportQuery = {
  dataPlan: SingleDataPlan | SharedDataPlan
}

export const getDataPlanReport = (sharedPlan: boolean) =>
  sharedPlan ? GET_SHARED_DATA_PLAN_REPORT : GET_SINGLE_DATA_PLAN_REPORT

const GET_SINGLE_DATA_PLAN_REPORT = gql`
  query GetSingleDataPlanReport($id: Int!, $resolution: String!, $toTimestamp: DateTime!, $fromTimestamp: DateTime!) {
    dataPlan: singlePlan(apiPlanId: $id) {
      __typename
      organization {
        name
      }
      apiPlanId
      totalDataUsage
      volumeAllowedAggregated
      volumeTotalAggregated
      volumeTopupAggregated
      terminal {
        terminal {
          id
          apiTerminal {
            singlePlans {
              totalDataUsage
              parentSharedPlan {
                id
              }
            }
            latestDataPlan {
              __typename
              ... on SingleDataPlanType {
                name
                totalDataUsage
                volumeTotalAggregated
              }
              ... on SharedDataPlanType {
                name
                totalDataUsage
                volumeTotalAggregated
              }
            }
          }
          nickname
          serialNumber
          modemSn
        }
      }
      totalUsageMetrics(resolution: $resolution, toTimeStamp: $toTimestamp, fromTimeStamp: $fromTimestamp) {
        timeStamp
        mbCount
      }
      start
      end
    }
  }
`

const GET_SHARED_DATA_PLAN_REPORT = gql`
  query GetSharedDataPlanReport($id: Int!, $resolution: String!, $toTimestamp: DateTime!, $fromTimestamp: DateTime!) {
    dataPlan: sharedPlan(apiPlanId: $id) {
      __typename
      apiPlanId
      totalDataUsage
      volumeAllowedAggregated
      volumeTotalAggregated
      volumeTopupAggregated
      sharedInstances {
        name
        totalDataUsage
        volumeAllowedAggregated
        volumeTotalAggregated
        volumeTopupAggregated
        terminal {
          id
          terminal {
            id
            nickname
            serialNumber
            modemSn
          }
        }
      }
      totalUsageMetrics(resolution: $resolution, toTimeStamp: $toTimestamp, fromTimeStamp: $fromTimestamp) {
        allUsages {
          timeStamp
          mbCount
        }
      }
      start
      end
    }
  }
`
